export default __webpack_public_path__ + "fec42356ab527664962f1b5aaa6ef299.svg";